import { BenefitType } from "../interfaces/enums/BenefitType";
import { EmploymentType } from "../interfaces/enums/EmploymentType";
import { PaymentPeriod } from "../interfaces/enums/PaymentPeriod";
import { PremiumStructure } from "../interfaces/enums/PremiumStructure";
import { ProductType } from "../interfaces/enums/ProductType";
import { SortBy } from "../../compare/enums/SortBy";

export function getProductTypeAsString(
    productType: ProductType,
    getShort = false
): string {
    switch (productType) {
        case ProductType.Life:
            return getShort ? "Life" : "Life insurance";
        case ProductType.Health:
            return getShort ? "Health" : "Health insurance";
        case ProductType.Trauma:
            return getShort ? "Trauma" : "Trauma insurance";
        case ProductType.Income:
            return getShort ? "Income" : "Income protection";
        case ProductType.Mortgage:
            return getShort ? "Mortgage" : "Mortgage insurance";
        case ProductType.WaiverOfPremium:
            return "Waiver Of Premium";
        default:
            return "Unknown";
    }
}

export function getProductTypePage(productType: ProductType): string {
    switch (productType) {
        case ProductType.Life:
            return "/life-insurance/";
        case ProductType.Health:
            return "/health-insurance/";
        case ProductType.Trauma:
            return "/trauma-insurance/";
        case ProductType.Income:
            return "/income-protection/";
        case ProductType.Mortgage:
            return "/mortgage-insurance/";
        default:
            return "/";
    }
}

export function getProductTypeListAsString(productTypes: ProductType[]): string {
    productTypes = [...new Set(productTypes)];

    const finalProduct = productTypes.pop();

    const titles = productTypes.map((pt) => {
        switch (pt) {
            case ProductType.Life:
                return "Life";
            case ProductType.Health:
                return "Health";
            case ProductType.Trauma:
                return "Trauma";
            case ProductType.Income:
                return "Income protection";
            case ProductType.Mortgage:
                return "Mortgage";
            case ProductType.WaiverOfPremium:
                return "Waiver Of Premium";
        }
    });

    if (titles.length > 0)
        return `${titles.join(", ")} and ${getProductTypeAsString(finalProduct)}`;

    return getProductTypeAsString(finalProduct);
}

export function getBenefitTypeAsString(benefitType: BenefitType): string {
    switch (benefitType) {
        case BenefitType.LifeCover:
            return "Life Insurance";
        case BenefitType.TraumaCover:
            return "Trauma Insurance";
        case BenefitType.HealthCover:
            return "Base Hospital Cover";
        case BenefitType.SpecialistsAndTests:
            return "Specialists and Tests";
        case BenefitType.GPCover:
            return "GP Insurance";
        case BenefitType.DentalAndOptical:
            return "Dental and Optical";
        case BenefitType.MortgageRepaymentCover:
            return "Repayment Cover";
        case BenefitType.IncomeProtection:
            return "Income Protection";
        case BenefitType.WaiverOfPremium:
            return "Waiver of Premium";
        default:
            return "";
    }
}

export function getPremiumStructureAsString(premiumStructure: PremiumStructure): string {
    switch (premiumStructure) {
        case PremiumStructure.Stepped:
            return "Stepped";
        case PremiumStructure.LevelTenYears:
            return "Level 10 years";
        case PremiumStructure.LevelToAgeSixtyFive:
            return "Level to Age 65";
        case PremiumStructure.LevelToAgeSeventy:
            return "Level To Age 70";
        case PremiumStructure.LevelToAgeEighty:
            return "Level To Age 80";
        case PremiumStructure.Unknown:
            return "Unknown";
        default:
            return "";
    }
}

export function getPaymentPeriodAsString(paymentPeriod: PaymentPeriod): string {
    switch (paymentPeriod) {
        case PaymentPeriod.TwoYears:
            return "2 Years";
        case PaymentPeriod.FiveYears:
            return "5 Years";
        case PaymentPeriod.UpToAgeSixtyFive:
            return "Up To Age 65";
        case PaymentPeriod.UpToAgeSeventy:
            return "Up To Age 70";
        case PaymentPeriod.Unknown:
            return "Unknown";
        default:
            return "";
    }
}

export function getEmploymentTypeAsString(employmentType: EmploymentType): string {
    switch (employmentType) {
        case EmploymentType.Employed:
            return "Employed";
        case EmploymentType.SelfEmployedOverThreeYears:
        case EmploymentType.SelfEmployedUnderThreeYears:
            return "Self-employed";
        case EmploymentType.Unknown:
            return "Unknown";
        default:
            return "";
    }
}

export function getSortByAsString(sortBy: SortBy): string {
    switch (sortBy) {
        case SortBy.CustomerService:
            return "Customer Service";

        case SortBy.PolicyFeatures:
            return "Policy Features";

        case SortBy.MostPopular:
            return "Most Popular";

        case SortBy.FinancialStrength:
            return "Financial Strength";

        case SortBy.LowestPrice:
            return "Lowest Price";

        case SortBy.HighestPrice:
            return "Highest Price";

        default:
            return "";
    }
}
